// inv/src/components/ui/SafeNavigate.jsx
import { Navigate } from 'react-router-dom';
import { useEffect, useState } from 'react';

const SafeNavigate = ({ to, replace = false, state = null }) => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!isClient) {
    return null;
  }

  return <Navigate to={to} replace={replace} state={state} />;
};

export default SafeNavigate; 